import React from 'react';
import { useEffect } from "react";
import { useLocation ,useNavigate} from "react-router-dom";
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroSection from '../components/home/HeroSection';
import WelcomeSection from '../components/home/WelcomeSection';
import ProblemsSection from '../components/home/ProblemsSection';
import ServicesGrid from '../components/home/ServicesGrid';
import HowWeWork from '../components/home/HowWeWork';
import ProjectsGallery from '../components/home/ProjectsGallery';
import ContactSection from '../components/home/ContactSection';
import OperationalDiagnostic from '../components/home/OperationalDiagnostic';
import ValueSection from "../components/home/ValueSection";
import CallToAction from "../components/home/CallToAction";
import PhilosophySection from "../components/home/PhilosophySection";
import Metric from "../components/home/Metric";
import OutcomesSection from "../components/home/OutcomesSection";


const HomePage = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.state?.scrollTo) {
      const el = document.getElementById(location.state.scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }
  }, [location ]);


  return (
    <div>
      <Navbar />
      <HeroSection />
      <Metric />
      {/* <WelcomeSection /> */}
      {/* <ProblemsSection /> */}
      <ServicesGrid />
      {/* <HowWeWork /> */}
      <OperationalDiagnostic />
      {/* <ProjectsGallery /> */}
      {/* <ContactSection /> */}
      <ValueSection />
      <OutcomesSection />
      <PhilosophySection />
      <CallToAction />
      <Footer />
    </div>
  );
};

export default HomePage;